<div class="so-chart-root"
  [class.so-chart-root--horizontal]="legendPosition() === 'left' || legendPosition() === 'right'"
  [class.so-chart-root--reverse]="legendPosition() === 'left'"
  [style]="'margin: ' + margin() + '; padding: ' + padding() + ';'">

  @if (useCustomLegends() && (legendPosition() === 'top' || legendPosition() === 'left') && legendItems().length > 0) {
    <div class="chart-legends"
      [class.chart-legends--top]="legendPosition() === 'top'"
      [class.chart-legends--side]="legendPosition() === 'left'"
      [class.chart-legends--detailed]="legendShowDetails()"
      [style.grid-template-columns]="legendColumns() > 0 ? 'repeat(' + legendColumns() + ', 1fr)' : ''">
      <ng-container *ngTemplateOutlet="legendTpl" />
    </div>
  }

  <div class="so-chart-canvas-wrap" [style.width]="width()" [style.height]="height()">
    <canvas [style]="'width: 100% !important; height: 100% !important; max-width: ' + width() + ' !important; max-height: ' + height() + ' !important;'" [id]="CHART_ID"></canvas>
  </div>

  @if (useCustomLegends() && (legendPosition() === 'bottom' || legendPosition() === 'right') && legendItems().length > 0) {
    <div class="chart-legends"
      [class.chart-legends--bottom]="legendPosition() === 'bottom'"
      [class.chart-legends--side]="legendPosition() === 'right'"
      [class.chart-legends--detailed]="legendShowDetails()"
      [style.grid-template-columns]="legendColumns() > 0 ? 'repeat(' + legendColumns() + ', 1fr)' : ''">
      <ng-container *ngTemplateOutlet="legendTpl" />
    </div>
  }
</div>

<ng-template #legendTpl>
  @for (item of visibleLegendItems(); track item.index) {
    <div
      class="legend-item"
      [class.legend-item--hidden]="item.hidden"
      [class.legend-item--detailed]="legendShowDetails()"
      [class.legend-item--active]="enableSegmentHighlight() && activeLegendIndex() === item.index"
      (click)="toggleLegendItem(item.index)">
      <span class="legend-color" [style.background-color]="item.color"></span>
      <div class="legend-content">
        <span class="legend-label">{{ item.label }}</span>
        @if (item.value !== null && item.percentage !== null) {
          <span class="legend-detail">{{ item.value | number }} · {{ item.percentage | number:'1.0-1' }}%</span>
        }
      </div>
    </div>
  }

  @if (overflowLegendItems().length > 0) {
    <div class="legend-overflow" [class.legend-overflow--active]="hasActiveOverflow()">
      <button type="button" class="legend-overflow__toggle" (click)="toggleOverflow()">
        <span class="legend-overflow__dot" [class.legend-overflow__dot--active]="hasActiveOverflow()"></span>
        <span class="legend-overflow__label">{{ overflowLabel() }}</span>
        <span class="legend-overflow__arrow" [class.legend-overflow__arrow--open]="overflowOpen()">&#9662;</span>
      </button>

      @if (overflowOpen()) {
        <div class="legend-overflow__dropdown">
          @for (item of overflowLegendItems(); track item.index) {
            <div
              class="legend-item legend-item--detailed legend-overflow__item"
              [class.legend-item--hidden]="item.hidden"
              [class.legend-overflow__item--selected]="activeLegendIndex() === item.index"
              (click)="onOverflowItemClick(item.index)">
              <span class="legend-color" [style.background-color]="item.color"></span>
              <div class="legend-content">
                <span class="legend-label">{{ item.label }}</span>
                @if (item.value !== null && item.percentage !== null) {
                  <span class="legend-detail">{{ item.value | number }} · {{ item.percentage | number:'1.0-1' }}%</span>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</ng-template>
